import temporaryDataReducerGenerator from './temporaryDataReducerGenerator';
import { processAccordingPostType } from '../../utils/processAccordingPostType';

const isPost = post => !!processAccordingPostType(post, { blog: true, poll: true });
const isReply = post => !processAccordingPostType(post, { blog: true, poll: true });

export const posts = temporaryDataReducerGenerator('posts', isPost);
export const postsByGroup = temporaryDataReducerGenerator('posts', isPost, post => post.group && post.group.id || post.group);
export const replies = temporaryDataReducerGenerator('posts', isReply);
export const repliesByPost = temporaryDataReducerGenerator('posts', isReply, reply => reply.parent && reply.parent.id || reply.parent);
export const threads = temporaryDataReducerGenerator('threads');
export const messagesByThread = temporaryDataReducerGenerator('messages', () => true, message => message.thread && message.thread.id || message.thread);



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/temporaryData/index.js